// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.gradient-bar{
    font-family: 'Montserrat', sans-serif; /* Default font */
}

.progress-bar {
    height: 18px;
    position:relative; /* relative here */
    border: 1px solid var(--gray-light);
    border-radius: 9px;
    background: rgb(255, 255, 255, 0.2);
}

.progress-bar-gradient {
    height: 100%;
    border-radius: 9px;
    position: relative;
    overflow: hidden;
    /* this will do the magic */
    mask:linear-gradient(#fff 0 0);
}
.progress-bar-gradient::before {
    content:"";
    position:absolute;
    top:0;
    left:0;
    bottom:0;
    width: calc(100% / var(--progress-value, 1));
    background-image: linear-gradient(90deg, rgba(0,165,141,1) 0%, rgba(20,194,64,1) 25%, rgba(236,250,22,1) 50%, rgba(252,144,27,1) 75%, rgba(255,38,34,1) 100%); /* your gradient here */
    background-size: 100% 100%;
    background-repeat: no-repeat;
}
`, "",{"version":3,"sources":["webpack://./src/css/horizontal-bar.css"],"names":[],"mappings":"AAAA;IACI,qCAAqC,EAAE,iBAAiB;AAC5D;;AAEA;IACI,YAAY;IACZ,iBAAiB,EAAE,kBAAkB;IACrC,mCAAmC;IACnC,kBAAkB;IAClB,mCAAmC;AACvC;;AAEA;IACI,YAAY;IACZ,kBAAkB;IAClB,kBAAkB;IAClB,gBAAgB;IAChB,2BAA2B;IAE3B,8BAA8B;AAClC;AACA;IACI,UAAU;IACV,iBAAiB;IACjB,KAAK;IACL,MAAM;IACN,QAAQ;IACR,4CAA4C;IAC5C,6JAA6J,EAAE,uBAAuB;IACtL,0BAA0B;IAC1B,4BAA4B;AAChC","sourcesContent":[".gradient-bar{\n    font-family: 'Montserrat', sans-serif; /* Default font */\n}\n\n.progress-bar {\n    height: 18px;\n    position:relative; /* relative here */\n    border: 1px solid var(--gray-light);\n    border-radius: 9px;\n    background: rgb(255, 255, 255, 0.2);\n}\n\n.progress-bar-gradient {\n    height: 100%;\n    border-radius: 9px;\n    position: relative;\n    overflow: hidden;\n    /* this will do the magic */\n    -webkit-mask:linear-gradient(#fff 0 0);\n    mask:linear-gradient(#fff 0 0);\n}\n.progress-bar-gradient::before {\n    content:\"\";\n    position:absolute;\n    top:0;\n    left:0;\n    bottom:0;\n    width: calc(100% / var(--progress-value, 1));\n    background-image: linear-gradient(90deg, rgba(0,165,141,1) 0%, rgba(20,194,64,1) 25%, rgba(236,250,22,1) 50%, rgba(252,144,27,1) 75%, rgba(255,38,34,1) 100%); /* your gradient here */\n    background-size: 100% 100%;\n    background-repeat: no-repeat;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
